import { Validation } from './../Validation';
import { Serialize } from './../Serialize';

export class Form {
    constructor(form, settings) {
        this.url = settings.url;
        this.userData = {
            customerSegment: settings.segment
        };
        this.form = form;
        this.validation = new Validation(this.form);
        this.serialize = new Serialize();

        this.form.querySelector('[name=prefPhoneNumber]').addEventListener('blur', (event) => {
            event.target.value = event.target.value.replace(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, '($1)-$2-$3');
        })
    }

    setUserData(key, value) {
        this.userData[key] = value;
        document.getElementById('userData').value = this._addUserData();
    }

    _addUserData() {
        return Object
            .keys(this.userData)
            .map((elem) => {
                return elem + '=' + this.userData[elem];
            })
            .join(",");
    }

    setInputArray(inputs) {
        let inputsArray = {};
        for (let input of inputs) {
            if (input.name === 'fullName') {
                const name               = input.value.split(' ');
                inputsArray['firstName'] = name[0];
                inputsArray['lastName']  = name[1];
            } else if (input.name === 'text') {
                // having issues with special characters so escaping them out...
                let _text = encodeURIComponent(input.value);
                // ... previously was only worried about about certain characters.
                // let _text = input.value.replace(/(&)/g, '%26');
                inputsArray['text'] = _text;
            } else {
                inputsArray[input.name] = input.value;
            }
        }

        return inputsArray;
    }
}



// WEBPACK FOOTER //
// ./src/modules/Shared/Form/index.js